import Modal from 'developer_components/newModal';
import EventEmitter from 'methods/eventEmitter';

function SuccessModal(content = '', footer = '<span class="link" data-modal_id="authorization">Войти</span>') {
    // наследуемся
    EventEmitter.call(this);

    this.modal_id  = 'successRegistration';
    this._$element = Modal.createFromHTML(
        `<div class="Message-modal container">
            <div class="background"></div>
            <div class="form">
                <div class="form-header">
                    <div class="mobile-wrapper">
                        <div class="logo"></div>
                        <button class="close-button js-modalClose"></button>
                    </div>
                    <div class="cross-wrapper"><div class="cross js-modalClose"></div></div>
                </div>
                <div class="form-content">${content}</div>
                <div class="form-footer">${footer}</div>
            </div>
        </div>`,
        {
            id: this.modal_id,
        }
    );

    // наследование
    Modal.call(this, this._$element, {
        modal_id: this.modal_id,
    });
}

SuccessModal.prototype = Object.create(Modal.prototype, {
    constructor: {
        value: SuccessModal,
        enumerable: false,
        writable: true,
    }
});

export default SuccessModal;